module.exports = __webpack_public_path__ + "img/aeroland-sass-image-01.5e9c7208.png";